import { makeStyles } from 'tss-react/mui'


const useStyles = makeStyles()((theme) => ({
    container: {
        height: '100%',
        width: '100%',
        display: 'flex',
        position: 'relative',
        boxSizing: 'border-box',
        lineHeight: 0,
        zIndex: 10,
        pointerEvents: 'none'
    },
    actionsContainer: {
        position: 'absolute',
        top: theme.spacing(0.5),
        right: theme.spacing(0.5),
        pointerEvents: 'all'
    }
}))

export default useStyles